module.exports = __webpack_public_path__ + "images/homepage-step3.svg";


//////////////////
// WEBPACK FOOTER
// ./_common/images/homepage-step3.svg
// module id = 161
// module chunks = 1